import { useRouter } from 'next/router';
import { NAV_LINKS } from '@utils/constants';

export const LeftNavType = {
  DEFAULT: 'DEFAULT',
  DASHBOARD: 'DASHBOARD',
  UPLOAD: 'UPLOAD',
  EDIT_UPLOAD: 'EDIT_UPLOAD',
  HIDDEN: 'HIDDEN',
} as const;

export const DASHBOARD_PATHNAMES = [
  NAV_LINKS.ProfileEdit,
  NAV_LINKS.Releases,
  NAV_LINKS.Earnings,
  NAV_LINKS.Upload,
  NAV_LINKS.UploadV2,
  NAV_LINKS.Edit,
  NAV_LINKS.NotificationsDashboard,
  NAV_LINKS.Community,
];

export const UPLOAD_PATHNAMES = [
  '/secret/dashboard/upload/[releaseType]/[draftId]/step/[stepId]',
  '/secret/dashboard/upload/single/new/step/1',
  '/secret/dashboard/upload/album/new/step/1',
  '/dashboard/upload/[draftId]/[stepId]',
];

const EDIT_UPLOAD_PATHNAMES = [
  '/dashboard/upload/edit/[releaseType]/[draftId]/step/[stepId]',
  '/dashboard/edit/[releaseId]/[stepId]',
];

const HIDDEN_PATHNAMES = ['/secret/dashboard/upload/[releaseType]/[draftId]/step/[stepId]/preview'];

export const useLeftNavType = () => {
  const { pathname } = useRouter();

  if (DASHBOARD_PATHNAMES.includes(pathname)) return LeftNavType.DASHBOARD;
  if (UPLOAD_PATHNAMES.includes(pathname)) return LeftNavType.UPLOAD;
  if (EDIT_UPLOAD_PATHNAMES.includes(pathname)) return LeftNavType.EDIT_UPLOAD;
  if (HIDDEN_PATHNAMES.includes(pathname)) return LeftNavType.HIDDEN;
  return LeftNavType.DEFAULT;
};
